import communityAbout from 'src/modules/community/communityAbout/reducer';
import communityHome from 'src/modules/community/communityHome/reducer';
import communityPosts from 'src/modules/community/communityPosts/reducer';
import home from 'src/modules/home/visitor/reducer';
import messages from 'src/modules/messages/reducer';
import needsAssessmentList from 'src/modules/needsAssessment/needsAssessmentList/reducer';
import needsAssessmentReport from 'src/modules/needsAssessment/needsAssessmentReport/reducer';
import newsfeed from 'src/modules/home/newsfeed/reducer';
import poll from 'src/modules/community/poll/reducer';
import post from 'src/modules/community/singlePost/reducer';
import profile from 'src/modules/user/profile/reducer';
import programs from 'src/modules/programs/reducer';
import search from 'src/modules/search/shared/reducer';
import tag from 'src/modules/tag/reducer';
import tagsList from 'src/modules/tagsList/reducer';
import write from 'src/modules/community/write/reducer';

const reduceReducers = (...reducers) => (state, action) => reducers.reduce((acc, r) => r(acc, action), state);

const pageReducers = {
  communityAbout,
  communityHome,
  communityPosts,
  home,
  messages,
  needsAssessmentList,
  needsAssessmentReport,
  newsfeed,
  profile,
  programs,
  search,
  singlePost: reduceReducers(post, poll),
  tag,
  tagsList,
  write,
};

export default pageReducers;
